import styled from '@emotion/styled'
import {COLORS} from '../constants'

/**
 * Inline KPI panel surface, rendered below the offer card's stats grid when the node's
 * KPIs are toggled open. Sits inside the card so opening it never shifts sibling cards
 * horizontally or scrolls the page (PT-5710) — it only grows this one card downward.
 */
export const Panel = styled.div`
  border-top: 1px solid ${COLORS.border};
  padding: 12px 16px 14px;
  background-color: ${COLORS.mutedBg};
`

/** Small uppercase caption heading the panel. */
export const PanelHeading = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.mutedText};
  margin-bottom: 8px;
`

/**
 * Body of the panel: the responsive KPI tile grid. Tiles wrap from four columns down to one
 * as the card narrows, so the panel never forces horizontal scrolling (PT-5711).
 */
export const PanelBody = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
  font-size: 13px;
  color: ${COLORS.foreground};
`
